// AUTO-GENERATED by asyncapi-cable from the cable AsyncAPI documents.
// Do not edit by hand — regenerate with the asyncapi-cable CLI.

import { Channel } from "@anycable/core";
import type { AdminNotification } from "../models/AdminNotification";

/** Alternatives declared for the operation — AsyncAPI treats a channel's messages as a union. */
export type AdminNotificationsData = AdminNotification;

/** Params the client supplies at subscribe time. */
export type AdminNotificationsParams = Record<string, never>;

export class AdminNotificationsChannel extends Channel<AdminNotificationsParams, AdminNotificationsData> {
  static identifier = "AdminNotificationsChannel";
}
